import React from 'react'
import { MuiProps } from '../../../infrastructure/materialUiThemeProvider'
import { t } from '../../../infrastructure/i18nextHelper'
import { Select, NumberField, DateRangePicker } from '../../common/customComponents'
import { VesselProduct, premiumUnits } from '../vesselModels'
import { hasFeature } from '../../../infrastructure/feature'
import { Item } from '../../common/components/select/types'

type FormulaPriceDataRowProps = {
    product: VesselProduct,
    priceIndexs: Item[],
    changeProduct: (product: VesselProduct) => void
    activateAdditionalPremium: boolean,
    quotationCalendars: { [priceIndexCode: string]: string[] }
}

export function FormulaPriceDataRow({ classes, product, priceIndexs, changeProduct, activateAdditionalPremium, quotationCalendars }: FormulaPriceDataRowProps & MuiProps) {
    let getHighlightedDates = () =>
        quotationCalendars[product.priceIndexCode ?? '']?.map(date => ({ date: date, color: '#DB7056' })) || []

    return (<div className={classes.productDataRow}>
        <Select label={t('vessels.label.product.priceIndexCode')}
            value={product.priceIndexCode}
            choices={priceIndexs}
            onChange={val => changeProduct({ ...product, priceIndexCode: val })} />
        {!hasFeature('VesselMultiplePricingPeriod') ?
            <DateRangePicker startDate={product.pricingStartDate} startLabel={t('vessels.label.product.pricingStartDate')}
                endDate={product.pricingEndDate} endLabel={t('vessels.label.product.pricingEndDate')} autoReplace={true}
                getHighlightedDates={getHighlightedDates}
                onPeriodChange={period =>
                    changeProduct({ ...product, pricingStartDate: period.startDate, pricingEndDate: period.endDate })} />
            : undefined}
        {product.premiumCurrency && !hasFeature('VesselMultiplePremium') ?
            <NumberField label={t('vessels.label.product.premium', { unit: product.premiumCurrency })}
                onChange={val => changeProduct({ ...product, premium: val })}
                text={product.premium}
                allowNegative={true} />
            : undefined}
        {product.premiumCurrency && hasFeature('VesselMultiplePremium') && activateAdditionalPremium &&
            <Select label={t('vessels.label.product.premiumUnit')}
                value={product.premiumCurrency}
                choices={premiumUnits}
                onChange={val => changeProduct({ ...product, premiumCurrency: val })} />}
    </div>)
}

type FixedPriceDataRowProps = {
    productUnit: string,
    changeFixedPrice: (fixedPrice: number | null) => void,
    value: number | null
}

export function FixedPriceDataRow({ classes, productUnit, changeFixedPrice, value }: FixedPriceDataRowProps & MuiProps) {
    return (<div className={classes.productDataRow}>
        <NumberField label={t('vessels.label.purchaseMovement.fixedPrice', { unit: productUnit })}
            onChange={val => changeFixedPrice(val)}
            text={value} />
    </div>)
}
